import React, { useEffect, useRef, useState } from "react";
import mercadoPagoLogo from "../assets/mercadopago.png";
import pagBankLogo from "../assets/pagbank.png";
import { callGetApi, callPostApi } from "../api/ApiCaller";
import { GET_PAYMENT_STATUS_GET, MERCADOPAGO_PUBLIC_KEY, PLAYER_DEPOSIT_POST, PLAYER_PROFILE_GET, PLAYER_TRANSACTION_HISTORY_GET } from "../api/ApiConst";
import ModalHalloween from "./common/ModalHalloween";
import toast from "react-hot-toast";
import { STATUS } from "../utils/Constants";
import { useBalance } from "../BalanceContext";
import { useNavigate } from "react-router-dom";
import BoletoPaymentPage from "./BoletoPaymentModal";
import { getCurrencySymbol } from '../utils/TextUtils';

const paymentMethods = [
    {
        name: "Mercado Pago",
        logo: mercadoPagoLogo,
        min: 5,
        max: 80000,
        id: "mercado",
    },
    {
        name: "PagBank",
        logo: pagBankLogo,
        min: 5,
        max: 80000,
        id: "pagBank",
    },
];

const paymentTypes = [
    {
        name: "🏦 Pix",
        id: "pix",
    },
    //  {
    //     name: "💳 Cartão de Crédito",
    //     id: "visa",
    // }, {
    //     name: "🧾 Boleto Bancário",
    //     id: "bolbradesco",
    // },
];

const quickAmounts = [10, 20, 50];
const Deposit = () => {
    const [activeTab, setActiveTab] = useState("deposit");
    const { walletBalance, getWalletBalance, hiddenBalance, setHiddenBalance, profileDetails: globalProfileDetails } = useBalance();
    console.log(globalProfileDetails)
    const [selectedMethod, setSelectedMethod] = useState(paymentMethods[0].id);
    const [selectedPaymentType, setSelectedPaymentType] = useState(paymentTypes[0].id);
    const [amount, setAmount] = useState("");
    const handleQuickAmount = (val) => setAmount(val);
    const [loading, setLoading] = useState(false);
    const [paymentModal, setPaymentModal] = useState(false);
    const [paymentData, setPaymentData] = useState(null);
    const [waitingTime, setWaitingTime] = useState(0);
    const timeRef = useRef()
    const [pollstart, setPollstart] = useState(false)
    const paymentRef = useRef()
    const [transactionType, setTransactionType] = useState("Credit");
    const [transactions, setTransactions] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [startDate, setStartDate] = useState(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]);
    const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
    const [form, setForm] = useState({
        cardNumber: "",
        cardName: "",
        cvv: "",
        expiry: ""
    });
    const [profileDetails, setProfileDetails] = useState(null);
    const navigate = useNavigate();
    const [boletoPaymentModal, setBoletoPaymentModal] = useState(false);
    const [boletoPaymentData, setBoletoPaymentData] = useState(null);
    const [paymentSuccesModal, setPaymentSuccessModal] = useState(false)

    useEffect(() => {
        getPlayerDetails();
    }, []);

    useEffect(() => {
        return () => {
            if (paymentRef.current) clearInterval(paymentRef.current);
            if (timeRef.current) clearInterval(timeRef.current);
        };
    }, []);

    useEffect(() => {
        if (pollstart && paymentData?.id) {
            handlePollStatus()
        }
    }, [pollstart, paymentData])

    useEffect(() => {
        if (waitingTime >= 300) {
            setLoading(false);
            toast.error("Payment failed", { id: "Toast" });
            clearInterval(paymentRef.current);
            clearInterval(timeRef.current);
            setPaymentData(null)
            setAmount(0)
            setPaymentModal(false)
            setPollstart(false)
            setWaitingTime(0)
            setAmount(0)
            setPaymentModal(false)
            setPollstart(false)
            getWalletBalance()
        }
    }, [waitingTime])

    useEffect(() => {
        if (startDate && endDate && activeTab === "history") {
            // Convert dates to timestamps
            const startTimestamp = new Date(startDate).getTime();
            const endTimestamp = new Date(endDate + 'T23:59:59').getTime(); // End of day

            callPostApi(PLAYER_TRANSACTION_HISTORY_GET.replace("{startDate}", startTimestamp).replace("{endDate}", endTimestamp), {
                pageSize: pageSize,
                pageNumber: pageNumber - 1
            }, {}, (response) => {
                setTransactions(response.responsePacket.data);
                setTotalPages(response.responsePacket.totalPages);
            });
        }
    }, [startDate, endDate, transactionType, pageSize, pageNumber, activeTab]);

    const getPlayerDetails = () => {
        callGetApi(PLAYER_PROFILE_GET, {}, (response) => {
            if (response.errorCode === STATUS.SUCCESS) {
                setProfileDetails({ ...response.responsePacket });
            }
        });
    }

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const validateCardDetails = (form) => {
        const errors = [];

        // Card number: must be 13-19 digits
        const cardNumber = form.cardNumber.replace(/\s/g, '');
        if (!/^\d{13,19}$/.test(cardNumber)) {
            errors.push("Invalid card number");
        }

        // Cardholder name: non-empty
        if (!form.cardName || form.cardName.trim() === "") {
            errors.push("Cardholder name is required");
        }

        // Expiry: MM/YY format
        const expiryRegex = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/;
        if (!expiryRegex.test(form.expiry)) {
            errors.push("Invalid expiry date");
        } else {
            const [month, year] = form.expiry.split("/");
            const expMonth = parseInt(month, 10);
            const expYear = 2000 + parseInt(year, 10);
            const now = new Date();
            const expiryDate = new Date(expYear, expMonth - 1, 1);
            if (expiryDate < now) {
                errors.push("Card has expired");
            }
        }

        // CVV: 3 or 4 digits
        if (!/^\d{3,4}$/.test(form.cvv)) {
            errors.push("Invalid CVV");
        }


        return errors;
    };



    const handleCardDeposit = async () => {
        const errors = validateCardDetails(form);
        setLoading(true)
        setPollstart(false)
        if (errors.length > 0) {
            toast.error(errors.join("\n"));
            return;
        }
        const mercadoPagoInstance = new window.MercadoPago(MERCADOPAGO_PUBLIC_KEY, {
            locale: "pt-BR",
        });



        const token = await mercadoPagoInstance.createCardToken({
            cardNumber: form.cardNumber,
            cardholderName: form.cardName,
            expiration_month: form.expiry.split("/")[0],
            expiration_year: "20" + form.expiry.split("/")[1],
            cardExpirationMonth: form.expiry.split("/")[0],
            cardExpirationYear: '20' + form.expiry.split("/")[1],
            securityCode: form.cvv,
            identificationType: 'CPF',
            identificationNumber: profileDetails?.cpf
        });

        const paymentMethods = await mercadoPagoInstance.getPaymentMethods({
            bin: form.cardNumber.substring(0, 6)
        });
        const paymentMethod = paymentMethods.results[0];

        const issuers = await mercadoPagoInstance.getIssuers({ paymentMethodId: paymentMethod.id, bin: form.cardNumber.substring(0, 6) });

        if (!paymentMethod.issuer.id || !paymentMethod.id) {
            toast.error("Invalid Card details");
            return;
        }
        callPostApi(PLAYER_DEPOSIT_POST, {
            transaction_amount: amount,
            payment_method_id: paymentMethod.id,
            token: token?.id,
            issuer_id: paymentMethod.issuer.id
        }, {}, (response) => {
            // if (response.errorCode == 1) {
            //     toast.error("Payment Failed")
            //     setForm({
            //         cardNumber: "",
            //         cardName: "",
            //         cvv: "",
            //         expiry: ""
            //     })
            //     setLoading(false)
            //     setAmount(0)
            //     setPaymentData(null);
            //     clearInterval(paymentRef.current);
            //     clearInterval(timeRef.current);
            //     setPollstart(false)
            // }
            // if (response.responsePacket.status === "approved") {
            //     setForm({
            //         cardNumber: "",
            //         cardName: "",
            //         cvv: "",
            //         expiry: ""
            //     })
            //     setPaymentSuccessModal(true);
            //     getWalletBalance()
            //     setAmount(0)
            //     setPaymentData(null);
            //     clearInterval(paymentRef.current);
            //     clearInterval(timeRef.current);
            //     setPollstart(false)
            // }
            // else if (response.responsePacket.status === "rejected") {
            //     setForm({
            //         cardNumber: "",
            //         cardName: "",
            //         cvv: "",
            //         expiry: ""
            //     })
            //     toast.error("Payment Failed")
            //     setAmount(0)
            //     setPaymentData(null);
            //     clearInterval(paymentRef.current);
            //     clearInterval(timeRef.current);
            //     setPollstart(false)
            // }
            if (response.errorCode == 0) {
                setPaymentData(response?.responsePacket);
                setPollstart(true)
                timeRef.current = setInterval(() => {
                    setWaitingTime((prev = 0) => prev + 1);
                }, 1000);
            }
            else {
                toast.error("Payment Failed")
                setLoading(false)
                setAmount(0)
                setPaymentData(null);
                clearInterval(paymentRef.current);
                clearInterval(timeRef.current);
                setPollstart(false)
                setForm({
                    cardNumber: "",
                    cardName: "",
                    cvv: "",
                    expiry: ""
                })
            }

        }, (e) => {
            toast.error("Payment Failed")
            setLoading(false)
            setAmount(0)
            setPaymentData(null);
            clearInterval(paymentRef.current);
            clearInterval(timeRef.current);
            setPollstart(false)
            setForm({
                cardNumber: "",
                cardName: "",
                cvv: "",
                expiry: ""
            })
        });

    }

    const handleBoletoDeposit = () => {
        setLoading(true)
        callPostApi(PLAYER_DEPOSIT_POST, {
            transaction_amount: amount,
            payment_method_id: selectedPaymentType,
            paymentMethod: selectedMethod
        }, {}, (response) => {
            setBoletoPaymentData(response?.responsePacket)
            setBoletoPaymentModal(true)
            setLoading(false)
        }, (e) => {
            setLoading(false)
        });
    }

    const handlePollStatus = () => {
        paymentRef.current = setInterval(() => {
            callGetApi(GET_PAYMENT_STATUS_GET.replaceAll("{paymentId}", paymentData?.id).replaceAll("{provider}", selectedMethod), {}, (response) => {
                if (response?.responsePacket === "Approved" || selectedMethod === "pagBank" && response?.responsePacket === "Paid") {
                    setLoading(false);
                    setPaymentModal(true);
                    setPaymentData(response?.responsePacket);
                    clearInterval(paymentRef.current);
                    clearInterval(timeRef.current);
                    setPollstart(false)
                    setPaymentData(null)
                    setWaitingTime(0)
                    setAmount(0)
                    setPaymentModal(false)
                    setPollstart(false)
                    setPaymentSuccessModal(true)
                    getWalletBalance()
                }
                else if (response?.responsePacket === "Rejected" || selectedMethod === "pagBank" && response?.responsePacket === "refused") {
                    setLoading(false);
                    toast.error("Payment failed", { id: "Toast" });
                    clearInterval(paymentRef.current);
                    clearInterval(timeRef.current);
                    setPollstart(false)
                    setPaymentData(null)
                    setPaymentModal(false)
                    setAmount(0)
                    setPaymentModal(false)
                    setWaitingTime(0)
                    setPollstart(false)
                }
                else if ((response?.responsePacket?.status || response?.responsePacket) === "in_process") {
                    toast.loading("Pending Review Manual")
                    clearInterval(paymentRef.current);
                    clearInterval(timeRef.current);
                    setPollstart(false)
                    setPaymentData(null)
                    setPaymentModal(false)
                    setAmount(0)
                    setPaymentModal(false)
                    setWaitingTime(0)
                    setPollstart(false)
                }
                else if (response?.responsePacket?.errorCode == 1) {
                    setLoading(false);
                    toast.error("Payment failed", { id: "Toast" });
                    clearInterval(paymentRef.current);
                    clearInterval(timeRef.current);
                    setPollstart(false)
                    setPaymentData(null)
                    setPaymentModal(false)
                    setAmount(0)
                    setPaymentModal(false)
                    setWaitingTime(0)
                    setPollstart(false)
                }
            }, (e) => {
                toast.error(e?.message || "Payment failed");
            });
        }, 5000)
    }

    const validateProfileDetails = () => {
        if (!profileDetails) return false;

        // List of required fields
        const requiredFields = [
            "cep",
            "city",
            "complement",
            "country",
            "cpf",
            "dateOfBirth",
            "email",
            "fullName",
            "gender",
            "nationality",
            "neighborhood",
            "number",
            "phone",
            "state",
            "street"
        ];

        for (let field of requiredFields) {
            const value = profileDetails[field];
            if (
                value === undefined ||
                value === null ||
                (typeof value === "string" && value.trim() === "")
            ) {
                toast.error(`Profile validation failed: ${field} is missing`);
                navigate("/personal-data");
                return false;
            }
        }

        return true;
    };

    const handleDeposit = () => {

        let valid = validateProfileDetails()
        if (!valid) {
            return;
        }

        if (selectedPaymentType == "visa") {
            handleCardDeposit();
            return;
        }
        if (selectedPaymentType == "bolbradesco") {
            handleBoletoDeposit();
            return;
        }
        setLoading(true)
        setPollstart(false)
        callPostApi(PLAYER_DEPOSIT_POST, {
            transaction_amount: amount,
            payment_method_id: selectedPaymentType,
            paymentMethod: selectedMethod
        }, {}, (response) => {
            setLoading(false);
            setPaymentModal(true);
            setPaymentData(response?.responsePacket);
            setPollstart(true)
            timeRef.current = setInterval(() => {
                setWaitingTime((prev = 0) => prev + 1);
            }, 1000);
        }, (e) => {
            toast.error(e.message);
            setLoading(false);
        });
    };

    const handleAmountChange = (val) => {
        let numeric = val.replace(/\D/g, ""); // keep only digits
        if (!numeric) {
            setAmount("0.00");
            return;
        }
        let floatVal = (parseInt(numeric, 10) / 100).toFixed(2);

        setAmount(floatVal);
    };

    // Store dates and type in separate variables


    // Handle start date change
    const handleStartDateChange = (value) => {
        if (value > endDate) {
            toast.error("Start date cannot be greater than end date", { id: "Toast" });
            return;
        }
        setStartDate(value);
    };

    // Handle end date change
    const handleEndDateChange = (value) => {
        if (value < startDate) {
            toast.error("End date cannot be less than start date", { id: "Toast" });
            return;
        }
        setEndDate(value);
    };

    // Handle transaction type change
    const handleTypeChange = (value) => {
        setTransactionType(value);
    };

    const closeModal = () => {
        setBoletoPaymentModal(false)
        setBoletoPaymentData(null)
    }

    function formatAmount(amount) {
        if (!amount) return "0";
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        }).format(amount);
    };

    // handle Copy Qr code button
    const handleCopyQrCode = () => {
        try {
            let qrCodeText = "";

            if (selectedMethod === "mercado") {
                qrCodeText = paymentData?.point_of_interaction?.transaction_data?.qr_code || "";
            } else if (selectedMethod === "pagBank") {
                qrCodeText = paymentData?.qr_codes?.[0]?.text || "";
            }

            if (!qrCodeText) {
                toast.error("QR code not found");
                return;
            }

            if (navigator.clipboard && navigator.clipboard.writeText) {
                // Secure context (https / localhost)
                navigator.clipboard.writeText(qrCodeText);
                toast.success("Pix Copia e Cola");
            } else {
                // Fallback (http / insecure context)
                const textArea = document.createElement("textarea");
                textArea.value = qrCodeText;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand("copy");
                document.body.removeChild(textArea);

                toast.success("Pix Copia e Cola");
            }
        } catch (err) {
            console.error("Clipboard copy failed:", err);
            toast.error("Failed to copy QR code. Please copy manually.");
        }
    };


    return (
        <div className="d-flex gap-2 col-12">
            <div className="col-10">
                <div
                    style={{
                        maxHeight: "85vh",
                    }}
                    className="main-div-content pb-4  overflow-y-scroll">
                    {/* Tabs */}
                    <div className="deposit-tabs">
                        <button
                            className={activeTab === "deposit" ? "active" : ""}
                            onClick={() => setActiveTab("deposit")}
                        >
                            Depósito
                        </button>
                        <button
                            className={activeTab === "history" ? "active" : ""}
                            onClick={() => setActiveTab("history")}
                        >
                            Histórico
                        </button>
                    </div>
                    {/* Payment Methods */}
                    {activeTab === "deposit" && <>
                        <div className="p-2 border-light rounded-2 mb-3" style={{ background: "#2F2F2F", transition: "all 0.5s ease" }}>
                            <div className="payment-methods">
                                {paymentMethods.map((method) => (
                                    <div
                                        key={method.id}
                                        className={`payment-method${selectedMethod === method.id ? " selected" : ""}`}
                                        onClick={() => {
                                            // if (method.id == "pagBank") {
                                            //     return;
                                            // }
                                            setSelectedMethod(method.id);
                                        }}
                                    >
                                        <img src={method.logo} alt={method.name} />
                                        {selectedMethod === method.id && <span className="checkmark">✔</span>}
                                    </div>
                                ))}
                            </div>
                            <div className="payment-methods mt-4 mb-4">
                                {paymentTypes.map((type) => (
                                    <div
                                        key={type.id}
                                        className={`payment-method${selectedPaymentType === type.id ? " selected" : ""} text-dark`}
                                        onClick={() => {
                                            setSelectedPaymentType(type.id);
                                        }}
                                    >
                                        <span>{type.name}</span>
                                        {selectedPaymentType === type.id && <span className="checkmark">✔</span>}
                                    </div>
                                ))}
                            </div>
                            <div className="payment-limits mb-0">
                                Pix &nbsp; Min: {getCurrencySymbol(globalProfileDetails?.currencyCode)} 5,00 &nbsp; Max: {getCurrencySymbol(globalProfileDetails?.currencyCode)} 80.000,00
                            </div>
                        </div>

                        {/* Amount Input */}
                        <div className="deposit-form">
                            <label htmlFor="deposit-amount" className="deposit-label">
                                Amount to deposit
                            </label>
                            <div className="deposit-input-row">
                                <span className="currency-prefix">{getCurrencySymbol(globalProfileDetails?.currencyCode)}</span>
                                <input
                                    id="deposit-amount"
                                    type="number"
                                    value={amount}
                                    onChange={(e) => handleAmountChange(e.target.value)}
                                    placeholder="0.00"
                                />
                            </div>
                            {selectedPaymentType === "visa" && (
                                <div className="card-payment-form border p-3 rounded">
                                    <h4 className="mb-3">Dados do Cartão</h4>

                                    {/* Card Number */}
                                    <div className="mb-3">
                                        <label className="form-label">Número do Cartão</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="cardNumber"
                                            placeholder="0000 0000 0000 0000"
                                            value={form.cardNumber}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    {/* Name + CVV */}
                                    <div className="row mb-3">
                                        <div className="col">
                                            <label className="form-label">Nome no Cartão</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="cardName"
                                                placeholder="Nome completo"
                                                value={form.cardName}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-4">
                                            <label className="form-label">CVV</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="cvv"
                                                placeholder="000"
                                                value={form.cvv}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    {/* Expiry + Installments */}
                                    <div className="row mb-3">
                                        <div className="col-4">
                                            <label className="form-label">MM/AA</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="expiry"
                                                placeholder="MM/AA"
                                                value={form.expiry}
                                                onChange={handleChange}
                                            />
                                        </div>

                                    </div>
                                </div>
                            )}
                            <div className="quick-amounts">
                                {quickAmounts.map((val) => (
                                    <button
                                        className={amount == val ? "active" : ""}
                                        key={val}
                                        type="button"
                                        onClick={() => handleQuickAmount(parseFloat(val).toFixed(2))}
                                    >
                                        {getCurrencySymbol(globalProfileDetails?.currencyCode)} {val}
                                        {amount == val && <span className="checkmark">✔</span>}
                                    </button>
                                ))}
                                <button
                                    className="deposit-btn"
                                    disabled={!amount || amount < 5 || loading}
                                    onClick={handleDeposit}
                                >
                                    {loading ? <div className="spinner-border" /> : "DEPOSIT"}
                                </button>
                            </div>

                        </div>
                    </>}
                    {activeTab === "history" && <>
                        <div style={{ transition: "all 0.5s ease" }} className="account-statement-filters">
                            <span className="account-statement-filter-icon">
                                {/* SVG filter icon */}
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M3 5h18M6 10h12M10 15h4" stroke="#B0B0B0" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                            </span>

                            {/* Dynamic date inputs */}
                            <div className="date-inputs">
                                <input
                                    className="account-statement-chip"
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => handleStartDateChange(e.target.value)}
                                    max={endDate}
                                />

                                <input
                                    className="account-statement-chip"
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => handleEndDateChange(e.target.value)}
                                    min={startDate}
                                />
                            </div>

                            {/* <select value={transactionType} className="account-statement-chip" onChange={(e) => handleTypeChange(e.target.value)}>
                                <option value="Credit">Credit</option>
                                <option value="Debit">Debit</option>
                            </select> */}
                        </div>


                        <div style={{ background: "#2F2F2F", borderRadius: "10px", overflow: "scroll" }} className="pb-2 px-2 account-statement-transactions">
                            <table className="transaction-table table ">
                                {transactions && transactions.length > 0 && <thead className=''>
                                    <tr>
                                        <th>Amount</th>
                                        <th>Date</th>
                                        <th>Customer Name</th>
                                        <th>Customer Mobile</th>
                                        <th>Payment Gateway</th>
                                        <th>Payment Status</th>
                                        <th>Transaction Ref ID</th>
                                    </tr>
                                </thead>}
                                <tbody className='table-bordered'>
                                    {transactions && transactions.length > 0 && transactions.map((transaction, index) => (
                                        <tr key={index} className="transaction-row">
                                            <td className={`transaction-amount  ${transaction.amount >= 0 ? 'positive' : 'negative'}`}>
                                                {getCurrencySymbol(globalProfileDetails?.currencyCode)} {Math.abs(transaction.amount).toFixed(2)}
                                            </td>
                                            <td className="transaction-date ">{new Date(transaction.createdAt).toLocaleDateString('pt-BR') + ' ' + new Date(transaction.createdAt).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) || 'N/A'}</td>
                                            <td className="customer-name ">{transaction.customerName || 'N/A'}</td>
                                            <td className="customer-mobile ">{transaction.customerMobile || 'N/A'}</td>
                                            <td className="payment-gateway ">{transaction.paymentGateway || 'N/A'}</td>

                                            <td className="payment-status ">
                                                <span
                                                    className={`status-badge ${transaction.paymentStatus?.toLowerCase()}`}
                                                    style={{
                                                        color: '#fff',
                                                        color:
                                                            (transaction.paymentStatus?.toLowerCase() === 'pending' || transaction.paymentStatus?.toLowerCase() === 'waiting') ? '#dc3545' : // red
                                                                (transaction.paymentStatus?.toLowerCase() === 'approved' || transaction.paymentStatus?.toLowerCase() === 'paid') ? '#28a745' : // green
                                                                    // (transaction.paymentStatus?.toLowerCase() === 'paid' || transaction.paymentStatus?.toLowerCase() === 'paid') ? '#28a745' : // green
                                                                    (transaction.paymentStatus?.toLowerCase() === 'rejected' || transaction.paymentStatus?.toLowerCase() === 'refused') ? '#ffc107' : // yellow
                                                                        undefined
                                                    }}
                                                >
                                                    <span className="d-flex status">
                                                        {(transaction.paymentStatus?.toLowerCase() === "rejected" || transaction.paymentStatus?.toLowerCase() === "refused") && <span><svg width="16" height="16" viewBox="0 0 16 16" style={{ verticalAlign: 'middle', marginRight: 4 }}>
                                                            <circle cx="8" cy="8" r="8" fill="#b91c1c" />
                                                            <line x1="5.5" y1="5.5" x2="10.5" y2="10.5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                                                            <line x1="10.5" y1="5.5" x2="5.5" y2="10.5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                                                        </svg></span>}
                                                        {(transaction.paymentStatus?.toLowerCase() === "paid" || transaction.paymentStatus?.toLowerCase() === "approved") ? 'Approved' :
                                                            (transaction.paymentStatus?.toLowerCase() === "waiting" || transaction.paymentStatus?.toLowerCase() === "pending") ? 'Pending' :
                                                                (transaction.paymentStatus?.toLowerCase() === "refused" || transaction.paymentStatus?.toLowerCase() === "rejected") ? 'Cancelled' : 'Pending'}
                                                    </span>

                                                </span>
                                            </td>
                                            <td className="transaction-ref-id ">{transaction.transactionRefId || 'N/A'}</td>
                                        </tr>
                                    ))}
                                    {transactions && transactions.length === 0 && (
                                        <tr>
                                            <td colSpan="6" className="text-center">No transactions found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <div className='d-flex gap-4 mt-4 mb-4 justify-content-end'>
                                <span className='text-white'>Items Per Page 10</span>
                                <span className='text-white'>{pageNumber} of {totalPages}</span>
                                <div className='d-flex gap-4 font-weight-bold'>
                                    <span
                                        onClick={() => pageNumber > 1 && setPageNumber(1)}
                                        className={`h-16 w-16 text-white cursor-pointer ${pageNumber <= 1 ? 'opacity-50' : ''}`}
                                        style={{ cursor: pageNumber <= 1 ? 'not-allowed' : 'pointer' }}
                                    >
                                        {"<<"}
                                    </span>
                                    <span
                                        onClick={() => pageNumber > 1 && setPageNumber(pageNumber - 1)}
                                        className={`h-16 w-16 text-white cursor-pointer ${pageNumber <= 1 ? 'opacity-50' : ''}`}
                                        style={{ cursor: pageNumber <= 1 ? 'not-allowed' : 'pointer' }}
                                    >
                                        {"<"}
                                    </span>
                                    <span
                                        onClick={() => pageNumber < totalPages && setPageNumber(pageNumber + 1)}
                                        className={`h-16 w-16 text-white cursor-pointer ${pageNumber >= totalPages ? 'opacity-50' : ''}`}
                                        style={{ cursor: pageNumber >= totalPages ? 'not-allowed' : 'pointer' }}
                                    >
                                        {">"}
                                    </span>
                                    <span
                                        onClick={() => pageNumber < totalPages && setPageNumber(totalPages)}
                                        className={`h-16 w-16 text-white cursor-pointer ${pageNumber >= totalPages ? 'opacity-50' : ''}`}
                                        style={{ cursor: pageNumber >= totalPages ? 'not-allowed' : 'pointer' }}
                                    >
                                        {">>"}
                                    </span>
                                </div>
                            </div>
                        </div>

                    </>}
                </div>
            </div>
            <div className="col-2">
                <div className="p-2" style={{ background: "#1A1A1A", color: "#fff", borderRadius: "8px" }}>
                    <div style={{ background: "#2F2F2F", borderRadius: "8px" }} className="p-2">
                        <span className="balance-label" style={{ fontSize: "14px", color: "#B0B0B0" }}>
                            {profileDetails?.fullName}
                        </span>
                        <div className="d-flex  align-items-center justify-content-between">
                            <span
                                className="balance-amount"
                                style={{
                                    transition: "all 0.3s ease",
                                    opacity: hiddenBalance ? 0.7 : 1,
                                    letterSpacing: hiddenBalance ? "2px" : "normal",
                                    transform: hiddenBalance ? "scale(0.95)" : "scale(1)",
                                    filter: hiddenBalance ? "blur(0.5px)" : "blur(0px)"
                                }}
                            >
                                {hiddenBalance ? "••••" : getCurrencySymbol(globalProfileDetails?.currencyCode) + " " + walletBalance?.toFixed(2)}
                            </span>
                            <div className="balance-actions d-flex gap-2" style={{ alignItems: "center" }}>
                                <svg
                                    onClick={() => setHiddenBalance(!hiddenBalance)}
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    style={{
                                        cursor: "pointer",
                                        opacity: 0.8,
                                        transition: "all 0.2s ease",
                                        padding: "2px",
                                        borderRadius: "4px"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.opacity = "1";
                                        e.target.style.background = "rgba(255,255,255,0.1)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.opacity = "0.8";
                                        e.target.style.background = "transparent";
                                    }}
                                    title={hiddenBalance ? "Show Balance" : "Hide Balance"}
                                >
                                    {hiddenBalance ? (
                                        // Eye-off icon when balance is hidden
                                        <>
                                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </>
                                    ) : (
                                        // Eye icon when balance is visible
                                        <>
                                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </>
                                    )}
                                </svg>
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    onClick={() => getWalletBalance()}
                                    style={{
                                        cursor: "pointer",
                                        opacity: 0.8,
                                        transition: "all 0.2s ease",
                                        padding: "2px",
                                        borderRadius: "4px"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.opacity = "1";
                                        e.target.style.background = "rgba(255,255,255,0.1)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.opacity = "0.8";
                                        e.target.style.background = "transparent";
                                    }}
                                    title="Refresh Balance"
                                >
                                    <path d="M23 4v6h-6M1 20v-6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalHalloween show={paymentModal} toggleModel={() => { setPaymentModal(false) }}>
                <div className="modal-dialog p-0 modal-sm">
                    <div style={{ background: "#2F2F2F", borderRadius: "8px", width: "400px" }} className="p-3  text-white rounded-3 d-flex flex-column align-items-center justify-content-center"
                    >
                        {/* Header with close button */}
                        <div className="w-100 d-flex justify-content-between align-items-center mb-2">
                            <h3 className="text-white fs-5 fw-normal m-0">
                                Aguardando Pagamento via Pix
                            </h3>
                            <span onClick={() => {
                                setPaymentModal(false)
                                setPaymentData(null)
                                setAmount(0)
                                setPollstart(false)
                                setWaitingTime(0)
                                setLoading(false)
                                clearInterval(paymentRef.current);
                                clearInterval(timeRef.current);
                            }}
                                className="text-white cursor-pointer fs-3 fw-bold">
                                ×
                            </span>
                        </div>

                        {/* Amount */}
                        <div className="w-100">
                            <h1 className="text-white fw-bold display-6 m-0">
                                {formatAmount(amount) ? formatAmount(amount) : "20,00"}
                            </h1>
                        </div>

                        {/* Instructions */}
                        <p className="text-white fs-6 text-start lh-base m-0 mb-2 w-100">
                            Conclua a transação use o aplicativo do seu banco para ler o QR-Code abaixo, ou use o código logo após clicar no botão Pix Copia e Cola.
                        </p>

                        {/* QR Code */}
                        <div className="bg-white rounded-3 p-1 mb-2">
                            {selectedMethod === "mercado" ? (
                                <img
                                    src={`data:image/png;base64,${paymentData?.point_of_interaction?.transaction_data?.qr_code_base64}`}
                                    alt="QR Code Pix"
                                    className="d-block"
                                    style={{ width: "200px", height: "200px" }}
                                />
                            ) :
                                (
                                    <img
                                        src={paymentData?.qr_codes[0].links[0].href}
                                        alt="QR Code Pix"
                                        className="d-block"
                                        style={{ width: "200px", height: "200px" }}
                                    />
                                )
                            }
                        </div>
                        <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            <button
                                style={{
                                    color: "#000",
                                    background: "#ff8000",
                                    width: "180px",
                                    height: "40px",
                                    fontSize: "14px"
                                }}
                                className="rounded-3"
                                onClick={handleCopyQrCode}
                            >
                                Pix Copia e Cola
                            </button>

                        </div>


                        {/* Validity Information */}
                        <div className="text-white text-center mb-2">
                            <span className="fs-6">
                                Código Pix válido até:
                            </span><br />
                            <span className="fs-5 fw-bold d-block mt-1">
                                {selectedMethod === "mercado" ? (
                                    new Date(paymentData?.date_created).toLocaleDateString('pt-BR', {
                                        day: '2-digit',
                                        month: 'long',
                                        year: 'numeric'
                                    }) + ', às ' +
                                    new Date(paymentData?.date_created).toLocaleTimeString('pt-BR', {
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    })
                                ) : (
                                    new Date(paymentData?.created_at).toLocaleDateString('pt-BR', {
                                        day: '2-digit',
                                        month: 'long',
                                        year: 'numeric'
                                    }) + ', às ' +
                                    new Date(paymentData?.created_at).toLocaleTimeString('pt-BR', {
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    })
                                )}
                            </span>
                        </div>

                        {/* Footer Instructions */}
                        <p className="text-white small text-start lh-base m-0 w-100">
                            Faça o Pix dentro do prazo informado para efetivar o seu depósito. Se o prazo não for cumprido, faça um novo depósito.
                        </p>
                    </div>
                </div>
            </ModalHalloween >
            <ModalHalloween show={boletoPaymentModal} toggleModel={() => {
                setBoletoPaymentModal(false)
                setBoletoPaymentData(null)
            }}>

                <div className="modal-dialog size-xl">
                    <BoletoPaymentPage data={boletoPaymentData} closeModal={closeModal} selectedMethod={selectedMethod} />
                </div>
            </ModalHalloween>
            <ModalHalloween show={paymentSuccesModal} toggleModel={() => setPaymentSuccessModal(false)}>
                <div className="modal-dialog p-0 modal-sm">
                    <div
                        style={{ background: "#2F2F2F", borderRadius: "8px", width: "500px" }}
                        className="p-3 text-white rounded-3 d-flex flex-column align-items-center justify-content-center"
                    >
                        {/* Close Button */}
                        <div className="w-100 d-flex justify-content-end mb-2">
                            <span
                                onClick={() => setPaymentSuccessModal(false)}
                                className="text-white cursor-pointer fs-3 fw-bold"
                            >
                                ×
                            </span>
                        </div>

                        {/* Success Message */}
                        <h2 className="text-white fw-bold mb-2">Pagamento realizado com sucesso!</h2>

                        {/* Optional small note */}
                        <p className="text-white small text-center m-0">
                            Obrigado pelo pagamento.
                        </p>

                        {/* Optional OK button */}
                        <button
                            style={{
                                color: "#000",
                                background: "#ff8000",
                                width: "120px",
                                height: "35px",
                                fontSize: "14px",
                                marginTop: "15px"
                            }}
                            className="rounded-3"
                            onClick={() => setPaymentSuccessModal(false)}
                        >
                            OK
                        </button>
                    </div>
                </div>
            </ModalHalloween>

        </div >
    );
};

export default Deposit;
